import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { DENSITY } from './VerticalOneColumnLayout.types';

export const $VerticalOneColumnLayout = styled.div<{ $isFluid: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${spacing(3.5)};
  width: ${({ $isFluid }) => ($isFluid ? '100%' : null)};

  &[data-density='${DENSITY.COMFORTABLE}'] {
    gap: ${spacing(7)};
  }

  &[data-density='${DENSITY.BLOCK}'] {
    gap: 0;
  }
`;
